import RowTemplate from "backbone/projects/templates/row.js.hamlc"
import ShowTemplate from "backbone/projects/templates/show.js.hamlc"
import LoadingTemplate from "backbone/projects/templates/loading.js.hamlc"
import EditTemplate from "backbone/projects/templates/edit.js.hamlc"
import ClipPublicationView from "backbone/projects/views/clip_publication_view.js"
import AddTopicsView from "backbone/projects/views/add_topics_view.js"
import AddSkillsView from "backbone/projects/views/add_skills_view.js"
import AssetsCollectionView from "backbone/projects/views/assets_collection_view.js"
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class ProjectView extends Backbone.View
  events:
    "submit form"               : "submitForm"
    "change .js-skills-input"   : "validateSkills"
    "change .js-topics-input"   : "validateTopics"
    "change #clip_use_image"    : "imageShowClicked"
    "click .js-delete-project"  : "deleteProject"
    "click .js-toggle-public"   : "togglePublic"
    "click .js-edit-project"    : "beginEdit"
    "click .js-cancel"          : "cancelForm"
    "dragover .assets-droparea" : "dragover"
    "dragleave .drag-drop-tint" : "dragleave"
    "drop .drag-drop-tint"      : "dragleave"
    "collapsible:toggled .collapsible-container" : "expand"

  initialize: ->
    @project = @options.project
    @onRemove = @options.onRemove
    @removeProject = @options.removeProject
    @collection = @options.collection
    @dispatcher = BackboneDispatcher.get_instance()
    @parentViewState = @options.parentViewState
    @setElement(RowTemplate(project: @project))
    @subviews = []
    @setupListeners()

  render: ->
    @removeSubviews()
    @subviews = []

    if @project.get("editMode")
      @setupEditMode()
    else
      @setupShowView()
      @project.set({expanded: false}, {silent: true}) if @project.get("expanded")

    contently.ui.setup_select2 @$el
    contently.ui.setup_validation @$el

    this

  setupEditMode: ->
    @$el.html EditTemplate
      project: @project
      skills: @options.skills
      freqSkills: @options.freqSkills
      storyFormats: @options.storyFormats
      topics: @options.topics
      freqTopics: @options.freqTopics
    @setupAssetViews()
    if @project.get("behance_id")
      @clipPublicationView = new ClipPublicationView
        el: @$el.find(".js-clip-publication-search")
      @subviews.push(@clipPublicationView)
    @setupS3Uploader()

  setupShowView: ->
    if @project.get("id")
      storyFormatHash = _.object(
        _.map(@options.storyFormats, (item) -> [item.value, item.label])
      )

      @$el.html ShowTemplate
        project: @project
        collection: @collection
        storyFormatHash: storyFormatHash
      if viewClass = @addSkillsOrTopicViewClass()
        @addSkillsOrTopicView = new viewClass(
          el: @$el.find(".js-add-skills-container")
          project: @project
          getFormData : @getFormData
          skills: @options.skills
          freqSkills: @options.freqSkills
          topics: @options.topics
          freqTopics: @options.freqTopics
        )
        @subviews.push(@addSkillsOrTopicView)

        @addSkillsOrTopicView.render()
    else
      @$el.html(LoadingTemplate(project: @project))

  addSkillsOrTopicViewClass: ->
    if @parentViewState
      if @parentViewState.get("addSkillsMode")
        AddSkillsView
      else if @parentViewState.get("addTopicsMode")
        AddTopicsView

  setupListeners: ->
    @listenTo(@project, "change", @render)
    @listenTo(@collection, "change:editMode", @render)
    #@listenTo(@parentViewState, "change", @render) if @parentViewState
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("s3UploadComplete", @s3UploadComplete)

  setupS3Uploader: ->
    options =
      assetableId: @project.get("id"),
      externalProcessing: true

    @dispatcher.trigger("setParentResourceOptions", options)

  s3UploadComplete: (upload) =>
    return unless upload.assetableId == @project.get("id") && @assetsCollectionView
    @assetsCollectionView.addAssetFromUpload(upload)

  setupAssetViews: ->
    @assetsCollectionView = new AssetsCollectionView(
      el: @$el.find(".js-image-collection-container")
      projectId: @project.get("id")
      assetsJSON: @project.get("assets")
    )
    @subviews.push(@AssetsCollectionView)
    @assetsCollectionView.render()

  validateSkills: ->
    input = @$el.find(".js-skills-input")
    if input.length
      input.parsley().validate()

  validateTopics: ->
    input = @$el.find(".js-topics-input")
    if input.length
      input.parsley().validate()

  dragover: ->
    @$el.find(".drag-drop-tint").removeClass('hidden')

  dragleave: ->
    @$el.find(".drag-drop-tint").addClass('hidden')

  removeSubviews: ->
    for subview in @subviews
      subview.remove() if subview

  remove: ->
    @removeSubviews()
    @stopListening()
    @dispatcher.unbind("s3UploadComplete", @s3UploadComplete)
    super()

  deleteProject: ->
    return if @collection.editingProject()
    @onRemove(@project)

  togglePublic: (e)->
    return if $(e.target).closest(".js-toggle-public").data('public') == @project.get("public")
    @project.save({public: !@project.get("public")}, {wait: true})

  submitForm: (e) ->
    e.preventDefault()
    $form = @$el.find("form")
    if $form.parsley().validate()
      @$el.maskLoading()
      @project.save(@getFormData($form), {
        wait: true,
        success: (model, response, options) =>
          contently.flash.notice("Your project was successfully updated.")
          @project.fetch() if @project.get("id")
          @project.set(editMode: false)
        error: (model, response, options) =>
          @$el.unmaskLoading()
          contently.flash.alert("Sorry, but an error occured while trying to update " + @project.truncatedTitle(30))
      })

  expand: ->
    if !@project.get("expanded") && @project.get("showNotificationDot")
      @project.set(showNotificationDot: false, expanded: true)

  create: ->
    @project.save({}, {
      wait: true
      success: =>
        @project.set(showNotificationDot: true)
      error: =>
        @project.set(createFailed: true)
    })

  beginEdit: (e)->
    return if @collection.editingProject()
    @project.fetch() if @project.get("id")
    @project.set(editMode: true)

  cancelForm: ->
    if @project.isNew()
      @removeProject(@project)
    else
      @removeSubviews()
      @assetsCollectionView = null
      @project.set(editMode: false)

  imageShowClicked: ->
    @project.set({use_image: !@project.get("use_image")}, {silent: true})

  getFormData: ($form) ->
    unindexedArray = $form.serializeArray()
    indexedArray = {}

    $.map unindexedArray, (n, i) ->
      if n['name'].indexOf("[]") > 0
        str = n['name']
        key = str.substring(0, str.indexOf('['))
        indexedArray[key] ?= []
        indexedArray[key].push(n['value'])
      else
        indexedArray[n['name']] = n['value']

    indexedArray



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/project_view.js.coffee